import { AppRouteProps } from "@bsm/component";
import { StudentEmmergencyContactContainer } from "./container/StudentEmmergencyContactContainer";

export const StudentEmmergencytContactRoutes: Array<AppRouteProps> = [
    {
        path: "emergencyContact",
        element: <StudentEmmergencyContactContainer />,
    },
];